// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2dJNV","errors":"Errors_errors__1_fMQ"};